import React, { useEffect, useState } from "react";
import {
  flaggedInvoiceDetail,
  verifyPendingInvoiceDetail,
} from "../../../redux/actions/invoiceVerificationAction";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";
import ArrowUp from "../../../assets/icons/indicator-up.svg";
import ArrowDown from "../../../assets/icons/indicator-down.svg";
import { getFileExtension } from "../../../components/utilites/helper";
import back from "../../../assets/icons/back.svg";
import CheckboxDetailsComponent from "../../../components/invoice-verification/checkbox-details-component";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import ReuploadInvoiceModal from "../../../components/modals/invoice-verification/reupload-invoice-modal";
import InvoiceImageOptions from "../../../components/invoice-verification/invoice-image-view/invoice-image-options";
import MainLayout from "../../../components/layouts/mainLayoutView/mainLayout";
import ProductsTable from "../../../components/invoice-verification/products-table";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import ChangeSaved from "../../../components/popups/ChangeSaved";
import ErrorPopup from "../../../components/popups/ErrorPopup";

const AiFlaggedInvoiceView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [invoiceViewData, setInvoiceViewData] = useState([]);
  const [invoiceOrderData, setInvoiceOrderData] = useState([]);
  const [openDetails, setOpenDetails] = useState([]);
  const [reuploadShow, setReuploadShow] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setshowSuccessMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setshowErrorMsg] = useState("");

  const initialValues = {
    id: params?.id ?? "",
    verification_json: {
      Distributor: false,
      Customer: false,
      Order: false,
      invoice_Details: false,
      Product: false,
    },
  };

  const validationSchema = Yup.object();

  const onSubmit = (values) => {
    console.log(values, "values");
    dispatch(
      verifyPendingInvoiceDetail(values, onVerifySuccess, onVerifyError)
    );
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    navigate("/invoice-verification/ai-flagged-invoices");
  };

  const onVerifySuccess = (data) => {
    console.log(data);
    setShowSuccessPopup(true);
    const str = data.data.message;
    const modifiedStr = str[0].toUpperCase() + str.slice(1);
    setshowSuccessMsg(modifiedStr);
    setTimeout(timeOutFnc, 2000);
  };

  const closeSuccessPopup = () => {
    setShowErrorPopup(false);
  };

  const onVerifyError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str1 = err.data.message;
    const modifiedStr1 = str1[0].toUpperCase() + str1.slice(1);
    setshowErrorMsg(modifiedStr1);
  };

  useEffect(() => {
    dispatch(flaggedInvoiceDetail({ id: params.id }, onSuccess, onError));
    setLoading(true);
  }, []);

  const onSuccess = (data) => {
    setInvoiceViewData(data?.data?.data?.invoice);
    setInvoiceOrderData(data?.data?.data?.order?.orderProducts);
    setLoading(false);
  };

  const onError = (err) => {
    console.log(err);
    setLoading(false);
  };

  const distributorData = [
    {
      heading: "Distributor ID",
      title: invoiceViewData?.distributor?.distributor_id
        ? invoiceViewData?.distributor?.distributor_id
        : "--",
    },
    {
      heading: "Firm Name",
      title: invoiceViewData?.distributor?.firm_name
        ? invoiceViewData?.distributor?.firm_name
        : "--",
    },
    {
      heading: "Mobile Number",
      title: invoiceViewData?.distributor?.mobile
        ? invoiceViewData?.distributor?.mobile
        : "--",
    },
    {
      heading: "GST Number",
      title: invoiceViewData?.distributor?.gst_number
        ? invoiceViewData?.distributor?.gst_number
        : "--",
    },
    {
      heading: "Address",
      title: `${
        invoiceViewData?.distributor?.address?.address_one
          ? invoiceViewData?.distributor?.address?.address_one
          : "--"
      } ${invoiceViewData?.distributor?.address?.address_two ? "," : ""} ${
        invoiceViewData?.distributor?.address?.address_two
          ? invoiceViewData?.distributor?.address?.address_two
          : ""
      }${invoiceViewData?.distributor?.address?.address_three ? "," : ""} ${
        invoiceViewData?.distributor?.address?.address_three
          ? invoiceViewData?.distributor?.address?.address_three
          : ""
      }`,
    },
    {
      heading: "state",
      title: invoiceViewData?.distributor?.state?.name
        ? invoiceViewData?.distributor?.state?.name
        : "--",
    },
    {
      heading: "City",
      title: invoiceViewData?.distributor?.city?.name
        ? invoiceViewData?.distributor?.city?.name
        : "--",
    },
  ];

  const customerData = [
    {
      heading: "Jivini’s Customer Code",
      title: invoiceViewData?.doctor
        ? invoiceViewData?.doctor?.code
          ? invoiceViewData?.doctor?.code
          : "--"
        : invoiceViewData?.pharmacy?.code
        ? invoiceViewData?.pharmacy?.code
        : "--",
    },
    {
      heading: "Customer Name",
      title: invoiceViewData?.doctor
        ? invoiceViewData?.doctor?.name
          ? invoiceViewData?.doctor?.name
          : "--"
        : invoiceViewData?.pharmacy?.pharmacy_name
        ? invoiceViewData?.pharmacy?.pharmacy_name
        : "--",
    },
    {
      heading: "Customer Type",
      title: invoiceViewData?.doctor
        ? "Doctor"
        : invoiceViewData?.customer_type == "pharmacy"
        ? "Pharmacy"
        : "--",
    },
    {
      heading: "Pharmacy Type",
      title: invoiceViewData?.doctor
        ? invoiceViewData?.doctor?.pharmacy_type
          ? invoiceViewData?.doctor?.pharmacy_type
          : "--"
        : invoiceViewData?.pharmacy?.pharmacy_type
        ? invoiceViewData?.pharmacy?.pharmacy_type
        : "--",
    },
    {
      heading: "City",
      title: invoiceViewData?.doctor
        ? invoiceViewData?.doctor?.city?.name
          ? invoiceViewData?.doctor?.city?.name
          : "--"
        : invoiceViewData?.pharmacy?.city?.name
        ? invoiceViewData?.pharmacy?.city?.name
        : "--",
    },
    {
      heading: "Mobile Number",
      title: invoiceViewData?.doctor
        ? invoiceViewData?.doctor?.mobile
          ? invoiceViewData?.doctor?.mobile
          : "--"
        : invoiceViewData?.pharmacy?.mobile
        ? invoiceViewData?.pharmacy?.mobile
        : "--",
    },
    {
      heading: "GST Number",
      title: invoiceViewData?.pharmacy?.gst_number
        ? invoiceViewData?.pharmacy?.gst_number
        : "--",
    },
    {
      heading: "Address",
      title: invoiceViewData?.doctor
        ? ` ${
            invoiceViewData?.doctor?.address?.address_one
              ? invoiceViewData?.doctor?.address?.address_one
              : "--"
          } ${invoiceViewData?.doctor?.address?.address_two ? "," : ""} ${
            invoiceViewData?.doctor?.address?.address_two
              ? invoiceViewData?.doctor?.address?.address_two
              : ""
          }${invoiceViewData?.doctor?.address?.address_three ? "," : ""} ${
            invoiceViewData?.doctor?.address?.address_three
              ? invoiceViewData?.doctor?.address?.address_three
              : ""
          }`
        : ` ${
            invoiceViewData?.pharmacy?.address?.address_one
              ? invoiceViewData?.pharmacy?.address?.address_one
              : "--"
          } ${invoiceViewData?.pharmacy?.address?.address_two ? "," : ""} ${
            invoiceViewData?.pharmacy?.address?.address_two
              ? invoiceViewData?.pharmacy?.address?.address_two
              : ""
          }${invoiceViewData?.pharmacy?.address?.address_three ? "," : ""} ${
            invoiceViewData?.pharmacy?.address?.address_three
              ? invoiceViewData?.pharmacy?.address?.address_three
              : ""
          }`,
    },
  ];

  const orderData = [
    {
      heading: "Order ID",
      title: invoiceViewData?.order?.order_id ?? "--",
    },
    {
      heading: "Order Date",
      title: invoiceViewData?.order?.createdAt
        ? moment(invoiceViewData?.order?.createdAt).format(
            "DD MMM YYYY HH:mm A"
          )
        : "--",
    },
    {
      heading: "Order Value",
      title: invoiceViewData?.order?.total
        ? `₹ ${invoiceViewData?.order?.total}`
        : "--",
    },
    {
      heading: "Order Status",
      title: invoiceViewData?.order?.status
        ? invoiceViewData?.order?.status
        : "--",
    },
    {
      heading: "Delivered  Date",
      title: invoiceViewData?.order?.delivery_date
        ? moment(invoiceViewData?.delivery_date).format("DD MMM YYYY HH:mm A")
        : "--",
    },
  ];

  const distributoInvoiceDetails = [
    {
      heading: "Distributor Invoice Id",
      title: invoiceViewData?.invoice_id ? invoiceViewData?.invoice_id : "--",
    },
    {
      heading: "Distributor Invoice Date",
      title: invoiceViewData?.invoice_date
        ? invoiceViewData?.invoice_date &&
          moment(invoiceViewData?.invoice_date).format("DD MMM YYYY HH:mm A")
        : "--",
    },
    {
      heading: "Invoice Value",
      title: invoiceViewData?.order?.total
        ? `₹ ${invoiceViewData?.order?.total}`
        : "--",
    },
  ];

  const flaggedReasonDetails = [
    {
      heading: "Flagged By",
      title: invoiceViewData?.flagged_by === "ai" ? "AI" : "Human",
    },
    {
      heading: "Flag Reason",
      title: invoiceViewData?.ai_flag_reason ?? "--",
    },
  ];

  const Breadcrumb = ({ match }) => (
    <span>
      {match?.route?.path?.endsWith("view/:id") &&
        (invoiceViewData?.distributor?.distributor_id
          ? ` / ${invoiceViewData?.distributor?.distributor_id} - view`
          : " / view")}
    </span>
  );

  return (
    <MainLayout breadcrumbData={Breadcrumb}>
      <ChangeSaved show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeSuccessPopup}
      />
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <LoadingSpinnerTable />
        </div>
      ) : (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize={true}
        >
          {({ setFieldValue, values }) => {
            const checkedValue = {
              Distributor: true,
              Customer: true,
              Order: true,
              invoice_Details: true,
              Product: true,
            };
            let Allchecked =
              JSON.stringify(checkedValue) ===
              JSON.stringify(values?.verification_json)
                ? false
                : true;
            return (
              <Form className="p-1">
                <ReuploadInvoiceModal
                  show={reuploadShow}
                  handleClose={() => setReuploadShow(false)}
                  verification_json={values?.verification_json}
                  id={params?.id}
                />
                <div className="search-container d-flex justify-content-between ">
                  <div
                    className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                    onClick={() => navigate(-1)}
                  >
                    <img src={back} alt="back_btn" />
                    <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                      BACK
                    </span>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <AdminButton
                      type="button"
                      background="#7065E4"
                      color="white"
                      width="110px"
                      style={{
                        textTransform: "uppercase",
                      }}
                      onClick={() => setReuploadShow(true)}
                    >
                      <span className="m-2">REUPLOAD</span>
                    </AdminButton>

                    <AdminButton
                      type="submit"
                      background="#2AD3E7"
                      color="white"
                      width="100px"
                      disabled={Allchecked}
                      style={{
                        textTransform: "uppercase",
                      }}
                    >
                      <span className="m-2">Verify</span>
                    </AdminButton>
                  </div>
                </div>
                <div
                  className="d-flex"
                  style={{ height: "90vh", overflow: "hidden" }}
                >
                  <div
                    className="p-4"
                    style={{
                      width: "50%",
                      overflowY: "auto",
                    }}
                  >
                    <div>
                      <div
                        style={{ background: "#ff6f5b20" }}
                        className="text_red px-3 py-2 rounded-2 fw_600"
                      >
                        Flagged Reason
                      </div>
                      <div className="my-4 px-2">
                        {flaggedReasonDetails.map((item, index) => (
                          <div
                            key={index}
                            className="col-sm-6 col-md-6 mx-4 mx-xl-0"
                          >
                            <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                              {item.heading}
                            </h5>
                            <p
                              className={`fs_15 fn_Nunito fw_500 text-capitalize text-wrap`}
                            >
                              {item.title}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>

                    <CheckboxDetailsComponent
                      title="Distributor Details"
                      data={distributorData}
                      openDetails={openDetails}
                      setOpenDetails={setOpenDetails}
                      keyWord={"Distributor"}
                      checked={values?.verification_json?.Distributor}
                      onChange={() => {
                        setFieldValue(
                          "verification_json.Distributor",
                          !values?.verification_json?.Distributor
                        );
                      }}
                    />
                    <CheckboxDetailsComponent
                      title="Customer Details"
                      data={customerData}
                      openDetails={openDetails}
                      setOpenDetails={setOpenDetails}
                      keyWord={"Customer"}
                      checked={values?.verification_json?.Customer}
                      onChange={() => {
                        setFieldValue(
                          "verification_json.Customer",
                          !values?.verification_json?.Customer
                        );
                      }}
                    />
                    <CheckboxDetailsComponent
                      title="Order Details"
                      data={orderData}
                      openDetails={openDetails}
                      setOpenDetails={setOpenDetails}
                      keyWord={"Order"}
                      checked={values?.verification_json?.Order}
                      onChange={() => {
                        setFieldValue(
                          "verification_json.Order",
                          !values?.verification_json?.Order
                        );
                      }}
                    />
                    <CheckboxDetailsComponent
                      title="Distributor invoice Details"
                      data={distributoInvoiceDetails}
                      openDetails={openDetails}
                      setOpenDetails={setOpenDetails}
                      keyWord={"invoice_Details"}
                      checked={values?.verification_json?.invoice_Details}
                      onChange={() => {
                        setFieldValue(
                          "verification_json.invoice_Details",
                          !values?.verification_json?.invoice_Details
                        );
                      }}
                    />
                    <div className="my-4">
                      <div className="invoice-basic-details-container my-auto d-flex justify-content-between align-items-center gap-2 cursor_pointer px-3">
                        <div>
                          <input
                            type="checkbox"
                            className="superCheck"
                            checked={values?.verification_json?.Product}
                            onChange={() => {
                              setFieldValue(
                                "verification_json.Product",
                                !values?.verification_json?.Product
                              );
                            }}
                          />
                        </div>
                        <div
                          onClick={() => {
                            if (openDetails.includes("Product")) {
                              setOpenDetails(
                                openDetails.filter((item) => item !== "Product")
                              );
                            } else {
                              setOpenDetails([...openDetails, "Product"]);
                            }
                          }}
                          className="w-100 d-flex align-items-center justify-content-between"
                        >
                          <label className="basic-title">Product Details</label>
                          <div>
                            <span>
                              {openDetails.includes("Product") ? (
                                <img src={ArrowDown} />
                              ) : (
                                <img src={ArrowUp} />
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                      {openDetails.includes("Product") && (
                        <div className="my-4 px-2">
                          <ProductsTable
                            data={invoiceOrderData}
                            distributorProductTable={
                              invoiceViewData?.distributorInvoiceProducts
                            }
                            total={invoiceViewData?.order?.total}
                            distributor={
                              invoiceViewData?.distributor?.firm_name
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    className="p-4"
                    style={{
                      width: "50%",
                      overflowY: "auto",
                      position: "relative",
                    }}
                  >
                    <div className="mx-auto mt-4">
                      <label className="color_747f9e text-nowrap fs_14 fw_500">
                        Invoice By
                      </label>
                      <p className="fs_15 fn_Nunito fw_500 text-capitalize">
                        {invoiceViewData?.distributor?.firm_name || "--"}
                      </p>
                    </div>

                    <div
                      style={{
                        position: "sticky",
                        top: "1rem",
                        zIndex: 10,
                        background: "rgba(231, 229, 255, 0.35)",
                        border: "2px solid #7065e4",
                        borderRadius: "10px",
                        height: "70.5vh",
                      }}
                    >
                      {invoiceViewData?.url &&
                      getFileExtension(invoiceViewData?.url) === "pdf" ? (
                        <div style={{ borderRadius: "10px", height: "70vh" }}>
                          <iframe
                            src={invoiceViewData?.url}
                            className="w-100 h-100"
                            style={{ borderRadius: "10px", border: "none" }}
                          />
                        </div>
                      ) : (
                        <InvoiceImageOptions image={invoiceViewData?.url} />
                      )}
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      )}
    </MainLayout>
  );
};

export default AiFlaggedInvoiceView;
